export default function () {
  const widgetName = "fairSecondarySlideshow";
  const widgetOpts = fairSecondarySlideshowOpts;
  let swiperImages;
  let swiperContent;

  const slideDelay = 8000;
  const enableDescription = false;

  const enablePagination = true;

  const swiperContainers = `
      <div class="swiper-container swiper-container-images">
        <div class="swiper-wrapper"></div>
              ${enablePagination ? '<div class="swiper-pagination"></div>' : ""}

      </div>
  
      <div class="content-wrap">
      <div class="content-wrap-inner">
            <div class="swiper-container swiper-container-content">
              <div class="swiper-wrapper"></div>
            </div>
        </div>
      </div>  
    `;

  // Slide Template - Images
  function buildSlideTemplateImages(slide) {
    const template = `
        <div class="swiper-slide">
          <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
      `;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {
    const title = `<h2 class="slide-title">${slide.Title}</h2>`;
    const description = `<p class="slide-description">${slide.Description}</p>`;

    const template = `
        <div class="swiper-slide">
          <div class="swiper-content-container">
            <div class="wrap-content-slide">
            ${title}
            ${enableDescription ? description : ""}
            </div>
          </div>
        </div>
      `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    if (widgetData.length <= 1) {
      $(`#${widgetName} .content-wrap .swiper-wrapper`).addClass(
        "single-slide"
      );
    }
    const swiperWidgetImagesWrapper = $(
      `#${widgetName} .swiper-container-images .swiper-wrapper`
    );
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`
    );

    widgetData.forEach(function (slide) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    const swiperWidgetImages = new Swiper(
      `#${widgetName} .swiper-container-images`,
      {
        speed: 600,
        autoplay: {
          delay: slideDelay,
          disableOnInteraction: false,
        },
        loop: widgetData.length > 1,
        watchOverflow: true,
        spaceBetween: 0,
        centeredSlides: false,
        preloadImages: false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        a11y: true,
        autoHeight: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      }
    );

    const swiperWidgetContent = new Swiper(
      `#${widgetName} .swiper-container-content`,
      {
        speed: 600,
        spaceBetween: 0,
        centeredSlides: false,
        loop: widgetData.length > 1,
        watchOverflow: true,
        a11y: true,
        autoHeight: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: `#${widgetName} .swiper-button-next`,
          prevEl: `#${widgetName} .swiper-button-prev`,
        },
        pagination: {
          el: `#${widgetName} .swiper-pagination`,
          clickable: true,
        },
      }
    );
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

    swiperImages = swiperWidgetImages;
    swiperContent = swiperWidgetContent;

    // Observer to stop autoplay when user is not looking at the slider
    const sliderToObserve = $(`#${widgetName} .swiper-container-images`).get(0);
    if (sliderToObserve) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              swiperWidgetImages.autoplay.start();
            } else {
              swiperWidgetImages.autoplay.stop();
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(sliderToObserve);
    }
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
    } else {
      console.log(response);
      console.log("Error: No Data for swiperWidget");
      $(".homepage .tier-3-container .slideshow-wrapper-secondary").remove();
      $(".homepage .tier-3-container").addClass("no-swiper-widget");
    }
    updateSwiper(swiperImages, swiperContent);
  });
}

function updateSwiper(swiperImages, swiperContent) {
  swiperImages.update();
  swiperContent.update();
}

export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}
